module.exports = __webpack_public_path__ + "static/media/ic-2.ab115b63.svg";